import { createSelector } from 'reselect';

const selectNewsLetterFiles = (state: any) => state.newsletterFiles;


export const selectNewsLetterFilesCurrentItem = createSelector([selectNewsLetterFiles], (newsletterFiles) => newsletterFiles.current);

export const selectNewsLetterFilesListItems = createSelector([selectNewsLetterFiles], (newsletterFiles) => newsletterFiles.list);

export const selectNewsLetterFilesItemById = (itemId: any) =>
    createSelector(selectNewsLetterFilesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectNewsLetterFilesQueryItem = createSelector([selectNewsLetterFiles], (newsletterFiles) => newsletterFiles.query);

export const selectNewsLetterFilesCreatedItem = createSelector([selectNewsLetterFiles], (newsletterFiles) => newsletterFiles.create);

export const selectNewsLetterFilesUpdatedItem = createSelector([selectNewsLetterFiles], (newsletterFiles) => newsletterFiles.update);

export const selectNewsLetterFilesReadItem = createSelector([selectNewsLetterFiles], (newsletterFiles) => newsletterFiles.read);

export const selectNewsLetterFilesDeletedItem = createSelector([selectNewsLetterFiles], (newsletterFiles) => newsletterFiles.delete);

export const selectNewsLetterFilesSearchedItems = createSelector([selectNewsLetterFiles], (newsletterFiles) => newsletterFiles.search);

export const selectNewsLetterFilesItemsCount = createSelector([selectNewsLetterFiles], (newsletterFiles) => newsletterFiles.count);

export const selectNewsLetterFilesItemsFilter = createSelector([selectNewsLetterFiles], (newsletterFiles) => newsletterFiles.filter);